import Model, { attr, belongsTo } from "@ember-data/model";

export default class NetworkCircuitModel extends Model {
  @attr type;
  @attr billing;

  @belongsTo("project", { async: false, inverse: "networkCircuits" }) project;
}
